import React, { useState, useEffect } from "react";
import Keycloak from "../../helpers/keycloak";
import { Redirect } from "react-router-dom";
import * as actions from "../../actions/auth_actions";
import { connect } from "react-redux";

import config from "config";

const SSOResponse = ({ authenticated, signinUserWithToken, signinUserError }) => {
    const [loading, setLoading] = useState(!authenticated);

    useEffect(() => {
        const keycloak = new Keycloak({
            url: config.AUTH_BASE_URL,
            realm: "opsense-main",
            clientId: "sso-rest-api",
        });

        keycloak
            .init({ onLoad: "check-sso", silentCheckSsoRedirectUri: "silent-check-sso.html" })
            .then((ssoAuthed) => {
                if (ssoAuthed) {
                    signinUserWithToken(keycloak.token);
                } else {
                    // localStorage.getItem('auth-error')
                    signinUserError("Unable to process loging request.");
                }
            })
            .catch((e) => {
                console.error(e);
                signinUserError("Unable to process loging request.");
            })
            .finally(() => setLoading(false));
    }, [signinUserWithToken, signinUserError]);

    if (loading) {
        return <div className="loader">Processing</div>;
    } else {
        return <Redirect to={{ pathname: "/" }} />;
    }
};

export default connect(({ auth }) => ({ authenticated: auth.authenticated, errorMessage: auth.error }), actions)(SSOResponse);
